import React from 'react';

import { IRoundGroup } from '../../../../../../store/admin/eventRounds/store';

import { useTeeSheetCreatorDispatch } from '../../Context/TeeSheetCreator.context';
import { EmptyTeamCard } from '../../../TeamsCreator/Components/EmptyTeamCard';

interface IProps {
  group: IRoundGroup;
}

export const AddNewTeamCard = (props: IProps) => {
  const { group } = props;
  const { dispatch } = useTeeSheetCreatorDispatch();

  const onActiveAddNewTeam = () => {
    dispatch({
      type: 'set',
      value: { attribute: 'addTeamActive', value: true }
    });
    dispatch({
      type: 'set',
      value: { attribute: 'groupIdToAdd', value: group.id }
    });

    dispatch({ type: 'set', value: { attribute: 'modalOpen', value: true } });
  };

  return (
    <EmptyTeamCard elevation={1} className="paper team-card empty" onClick={onActiveAddNewTeam}>
      <span>+</span>
      <span>ADD NEW TEAM</span>
    </EmptyTeamCard>
  );
};
